export default __webpack_public_path__ + "static/media/Technologies.66fa102d.png";